export default "__VITE_ASSET__88832bf3__"